import { Component } from '@angular/core';
import { SimpleModalComponent } from '@looorent/ngx-simple-modal';

@Component({
    selector: 'app-actionviolationmodal',
    templateUrl: './actionviolationmodal.component.html',
    styleUrls: ['./actionviolationmodal.component.scss'],
    standalone: false
})
export class ActionviolationmodalComponent extends SimpleModalComponent<any, null> {
  public violation: any = null;

  constructor() {
    super();
  }
} 
